/** Lead CRM Funnel — admin UI config (mirrors Lead CRM Funnel spec doc). */

export const LEAD_TRAFFIC_SOURCES = [
  { id: "WEBSITE_CONTACT_FORM", label: "Website Contact Form", channel: "online" },
  { id: "WEBSITE_SERVICE_INQUIRY", label: "Website Service Inquiry", channel: "online" },
  { id: "WHATSAPP", label: "Whatsapp", channel: "online" },
  { id: "GOOGLE_ADS", label: "google", channel: "online" },
  { id: "FACEBOOK_ADS", label: "Facebook", channel: "online" },
  { id: "INSTAGRAM", label: "instagram", channel: "online" },
  { id: "GOOGLE_BUSINESS_PROFILE", label: "Google Business Profile", channel: "online" },
  { id: "ORGANIC_SEARCH", label: "Organic Search (SEO)", channel: "online" },
  { id: "REFERRAL_PROGRAM", label: "refer by someone", channel: "online" },
  { id: "DIRECT_WEBSITE", label: "visiting directly", channel: "online" },
  { id: "EMAIL_CAMPAIGN", label: "Email Campaign", channel: "online" },
  { id: "SMS_CAMPAIGN", label: "SMS Campaign", channel: "online" },
  { id: "LINKEDIN", label: "LinkedIn", channel: "online" },
  { id: "YOUTUBE", label: "YouTube", channel: "online" },
  { id: "GOOGLE_DISPLAY_ADS", label: "Google Display Ads", channel: "online" },
  { id: "META_LEAD_ADS", label: "Meta Lead Ads", channel: "online" },
  { id: "PARTNER_REFERRAL", label: "Partner Referral", channel: "offline" },
  { id: "HOSPITAL_REFERRAL", label: "Hospital Referral", channel: "offline" },
  { id: "DOCTOR_REFERRAL", label: "Doctor Referral", channel: "offline" },
  { id: "CARE_MANAGER_REFERRAL", label: "Care Manager Referral", channel: "offline" },
  { id: "CAREGIVER_REFERRAL", label: "Caregiver Referral", channel: "offline" },
  { id: "EXISTING_CUSTOMER_REFERRAL", label: "Existing Customer Referral", channel: "offline" },
  { id: "EMPLOYEE_REFERRAL", label: "Employee Referral", channel: "offline" },
  { id: "PHONE_CALL", label: "Phone Call Inquiry", channel: "offline" },
  { id: "COMMUNITY_EVENT", label: "Community Event/Camp", channel: "offline" },
  { id: "WEBINAR", label: "Webinar", channel: "online" },
  { id: "OFFLINE_CAMPAIGN", label: "Offline Marketing Campaign", channel: "offline" },
  { id: "QR_CODE", label: "QR Code Scan", channel: "offline" },
  { id: "MOBILE_APP", label: "Mobile App", channel: "online" },
  { id: "CUSTOMER_SUPPORT", label: "Customer Support Team", channel: "offline" },
  { id: "MANUAL_ENTRY", label: "Manual Entry", channel: "offline" },
  { id: "OTHER", label: "others", channel: "online" },
];

/** Subset shown on customer/caregiver signup — ids must exist in LEAD_TRAFFIC_SOURCES. */
export const CUSTOMER_SIGNUP_LEAD_SOURCES = LEAD_TRAFFIC_SOURCES.filter((source) =>
  [
    "GOOGLE_ADS",
    "FACEBOOK_ADS",
    "INSTAGRAM",
    "WHATSAPP",
    "REFERRAL_PROGRAM",
    "DIRECT_WEBSITE",
    "OTHER",
  ].includes(source.id)
);

/** Subset shown on caregiver signup — ids must exist in LEAD_TRAFFIC_SOURCES. */
export const CAREGIVER_SIGNUP_LEAD_SOURCES = LEAD_TRAFFIC_SOURCES.filter((source) =>
  [
    "GOOGLE_ADS",
    "FACEBOOK_ADS",
    "INSTAGRAM",
    "WHATSAPP",
    "REFERRAL_PROGRAM",
    "CAREGIVER_REFERRAL",
    "DIRECT_WEBSITE",
    "OTHER",
  ].includes(source.id)
);

export const LEAD_CRM_FILTER_OPTIONS = {
  userTypes: [
    { id: "all", label: "All users" },
    { id: "customer", label: "Customer" },
    { id: "caregiver", label: "Caregiver" },
  ],
  serviceTypes: [
    { id: "", label: "All service types" },
    { id: "FULL_TIME", label: "Long term" },
    { id: "HOURLY", label: "Hourly" },
    { id: "SHORT", label: "Short term" },
  ],
  subscriptionPlans: [
    { id: "", label: "All plans" },
    { id: "Silver", label: "Silver" },
    { id: "Gold", label: "Gold" },
    { id: "Platinum", label: "Platinum" },
  ],
  exportFormats: [
    { id: "csv", label: "CSV" },
    { id: "pdf", label: "PDF (print)" },
  ],
};

export const LEAD_CRM_ALERT_RULES = [
  "Registration conversion drops below threshold",
  "Subscription conversion drops below threshold",
  "Hire conversion drops below threshold",
  "No new hires in 24 hours",
  "Caregiver shortage in a city",
  "High profile abandonment",
  "High subscription abandonment",
];
